import 'ag-grid-enterprise';
import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import { LicenseManager } from 'ag-grid-enterprise';
import { Configuration } from './core/configuration';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(timezone);

LicenseManager.setLicenseKey(Configuration.agGridLicense || '');

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
